import React from 'react';
function Checkboxes({ size, stroke = 'currentColor', ...otherProps }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={stroke}
      {...otherProps}
    >
      <path d="M14.759 3H9.24C8.556 3 8 3.556 8 4.241V9.76C8 10.444 8.556 11 9.241 11h5.518C15.444 11 16 10.444 16 9.759V4.24C16 3.556 15.444 3 14.759 3z" />
      <path strokeLinecap="round" strokeLinejoin="round" d="M16 4l-4 4-1.5-1.5" />
      <path d="M14.759 13H9.24C8.556 13 8 13.556 8 14.241v5.518C8 20.444 8.556 21 9.241 21h5.518c.685 0 1.241-.556 1.241-1.241V14.24c0-.685-.556-1.241-1.241-1.241z" />
    </svg>
  );
}

export default Checkboxes;
